import React, { useContext } from "react";
import { Space, Tag } from "antd";
import { context } from "../../context/context";

const PlaceLinkTag = ({ tags }) => {
    const { linkTags, setLinkTags } = useContext(context);

    const handleDeleteLink = (url) => {
        const newLinks = linkTags.filter((link) => link.url !== url);
        setLinkTags(newLinks);
    };

    return (
        <Space wrap>
            {tags?.map((tag) => {
                return (
                    <Tag
                        color="blue"
                        closeIcon
                        key={tag.url}
                        onClose={() => handleDeleteLink(tag.url)}
                    >
                        {tag.title}
                    </Tag>
                );
            })}
        </Space>
    );
};

export default PlaceLinkTag;
